export default "__VITE_ASSET__BGxW2sSL__"